export default __webpack_public_path__ + "static/media/bg.369e8b73.webp";